export default __webpack_public_path__ + "static/media/sico_palais_royal.4f934447.jpg";